<template>
    <div v-if="isOppanAvailable">
        <div style="padding: 0 18px">
            <h1>Revalidate ACU Approval</h1>
            <p>You may revalidate a recently issued ACU approval to extend its validity. We will reassess your eligibility for Annual Check Up availment.</p>
        </div>

        <v-card class="elevation-10" style="margin: 10px 0">
            <v-card-title style="background-color: #DDD; font-size: 16px; font-weight: 600;">
                ACU INFORMATION FOR &nbsp;<v-chip color="teal darken-3" style="font-weight: 600" outlined>
                    {{ approval_no.OPAN_N }}
                </v-chip>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    v-if="approval_no && approval_no.OPAN_N"
                    v-model="approval_no.OPAN_N"
                    label="APPROVAL NO.:"
                    color="teal"
                    readonly
                    autocomplete="nope"
                />
                <v-text-field
                    v-if="approval_no && approval_no.hosp_name"
                    v-model="approval_no.hosp_name"
                    label="HOSPITAL NAME:"
                    color="teal"
                    readonly
                    autocomplete="nope"
                />
                <v-text-field
                    v-if="approval_no && approval_no.APPR_D"
                    v-model="apprDate"
                    label="APPROVAL DATE:"
                    color="teal"
                    readonly
                    autocomplete="nope"
                />
                <v-text-field
                    v-if="approval_no && approval_no.VALI_D"
                    v-model="valiDate"
                    label="VALID UNTIL:"
                    color="teal"
                    readonly
                    autocomplete="nope"
                />
            </v-card-text>
        </v-card>
        <div style="padding: 0 18px">
            <h1>Disclaimer</h1>
            <p>The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.</p>
            <v-form ref="form" v-model="valid" @submit.prevent="submit">
                <v-checkbox
                    v-model="validTerms"
                    :rules="[(v)=>!!v||'This checkbox is required.']"
                    label="I understand and accept the terms of this approval."
                />
                <v-container class="requestWrapper">
                    <v-btn
                        class="teal white--text"
                        :disabled="!valid"
                        :loading="loading"
                        type="submit"
                    >
                        <h1>Revalidate</h1>
                    </v-btn>
                </v-container>
            </v-form>
        </div>
    </div>
    <div v-else style="padding: 0 18px;">
        <h1>No approvals to revalidate.</h1>
        <p>To request an approval, go to Annual Check-Up Request.</p>
    </div>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import { mapGetters, mapActions } from 'vuex'
export default {
    props: ['isOppanAvailable', 'approval_no'],
    data: () => ({
        validTerms: false,
        valid: true,
        submit_enabled: true,
        loading: false
    }),
    computed: {
        ...mapGetters(['revalidateApprovalFuncData']),
        apprDate() {
            return moment(this.approval_no.APPR_D).format('MMMM D, YYYY')
        },
        valiDate() {
            return moment(this.approval_no.VALI_D).format('MMMM D, YYYY')
        }
    },
    watch: {
        revalidateApprovalFuncData(newVal) {
            if (newVal && newVal.data) {
                this.submit_enabled = true
                this.loading = false
                this.$emit('generateResult', newVal)
            }
        }
    },
    methods: {
        ...mapActions(['getCsrfToken', 'revalidateApproval', 'getACURecentApproval', 'revalidateApprovalFunc']),
        submit() {
            if (this.$refs.form.validate()) {
                this.submit_enabled = false
                this.loading = true
                let payload = {
                    MEMBN: this.$cookies.get('usermembn'),
                    OPAN_N: this.approval_no.OPAN_N,
                    MSU_C: this.approval_no.hosp_msu_code,
                    HOSP_NAME: this.approval_no.hosp_name
                }
                this.revalidateApprovalFunc(payload)
            }
        }
    }
}
</script>

<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
h1 {
    font-size: 18px;
}
</style>
